<template>
    <div>
        <b-form-input size="sm" id="description" name="description" class="border-left-0 border-right-0 border-bottom-0" v-model="form.description" placeholder="Set description (optional)" @keyup="debouncedUpdate" @change="debouncedUpdate" />
    </div>
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapState, mapActions } from "vuex"

import debounce from 'lodash/debounce'

export default FormExtension.extend({
    name: 'procedure-description-form',
    props: ['item'],
    data() {
        return {
            form: new Form({
                description: "",
                consistency_token: null
            }),

            debouncedUpdate: null
        }
    },
    watch: {
        item: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form.withData(val)
                }
            }
        }
    },
    methods: {
        ...mapActions('procedures', ['updateDecursusProcedure']),
        save() {
            this.updateDecursusProcedure({id: this.item?.id, data: this.form.data()}).then((updated) => {
                this.form.withData(updated)
            })
            .catch(errors => {
                if (errors.response) {
                    this.notify("Error", "Something went wrong", 'danger')
                }
            })
        }
    },
    created() {
        // Initialize the debounced function in the correct context
        this.debouncedUpdate = debounce(this.save, 1000)
    },
    beforeDestroy() {
        this.debouncedUpdate.cancel()
    }
})
</script>